import {
  CheckedCircleIcon,
  VideoFillIcon,
  CameraIcon,
  PhoneLandscapeIcon,
  SunFillIcon,
  VolumeIcon,
  CrossCircledIcon,
  ShirtIcon,
  GlassesIcon,
  EyeIcon,
  AvatarWithBgIcon,
  HandIcon,
} from "../components/Icons/DosDontsIcons";

export enum GuideTabProps {
  TEXT_INSTRUCTIONS_TAB = "Text instructions",
  VIDEO_INSTRUCTIONS_TAB = "Video instructions",
}
export const guideTabs = [GuideTabProps.TEXT_INSTRUCTIONS_TAB, GuideTabProps.VIDEO_INSTRUCTIONS_TAB];

export const DosAndDontsInstructionData = [
  {
    heading: "Do's",
    headingIcon: <CheckedCircleIcon />,
    listPoints: [
      { icon: <VideoFillIcon />, text: "Set up your HD camera or recording software" },
      { icon: <CameraIcon />, text: "If using a smartphone, film in landscape" },
      { icon: <PhoneLandscapeIcon />, text: "Make sure your face & upper body are in focus" },
      { icon: <SunFillIcon />, text: "Ensure the recording space is quiet and well-lit" },
      { icon: <VolumeIcon />, text: "Speak naturally, we'll capture tone & emotion" },
    ],
  },
  {
    heading: "Dont's",
    headingIcon: <CrossCircledIcon />,
    listPoints: [
      { icon: <ShirtIcon />, text: "Avoid clothes that blend into the background" },
      {
        icon: <GlassesIcon />,
        text: "Avoid accessories that block your head & face like hats, earrings, or thick glasses.",
      },
      { icon: <EyeIcon />, text: "Don't turn your head away from the camera" },
      { icon: <AvatarWithBgIcon />, text: "Avoid backgrounds that are busy or moving" },
      {
        icon: <HandIcon />,
        text: "Don't move around too much or exaggerate movements, like waving your hands",
      },
    ],
  },
];
